import * as Yup from "yup";

export const settingValidationSchema = Yup.object().shape({
  SettingKey: Yup.string().required("Setting Key is required"),
  SettingValue: Yup.string(),
  SettingType: Yup.string(),
  IsActive: Yup.boolean().required("Status is required"),
});
